
































import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import PageTitle from '../../core/components/PageTitle.vue';
import MachineDetail from '../../insurance/components/MachineDetail.vue';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { paramsOptions } from '../../core/models';
import { copyTextToClipboard, EventBus, getParameterFromUrl, TypeEventBus } from '../../core/utils/';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { InsuranceServices } from '../api/InsuranceServices';
import loading from 'vue-loading-overlay'
import { farmingType, farmingTypeOptions, getMachineTypeText } from '../helpers';

@Component({
    components: {
        loading,
        Summary,
        Combobox,
        Button,
        Input,
        PageTitle,
        MachineDetail
    }
})
export default class InsuranceMachineViewDetail extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    farmingId: null | string = null;
    vehicleId: null | string = null;
    vehicleType: null | string = null;
    pageTitle: string = 'Detalle de Maquina';
    isLoading: boolean = true;
    showInfo: boolean = false;
    visibleMachineDetail: boolean = false;
    vehicleAction: string = '';
    patchDataSowingDetail: object = {};

    mounted(){
        // EventBus.$on(TypeEventBus.REFRESH_MACHINE_VIEW, () => {
        //     this.visibilityMachineDetail(false);
        // })
        this.$nextTick(() => {
              this.setInitialPageTitle();  
              this.farmingId = getParameterFromUrl(paramsOptions.farming_id);
              this.vehicleId = getParameterFromUrl(paramsOptions.vehicle_id);
              this.vehicleType = getParameterFromUrl(paramsOptions.vehicle_type);
                if(this.farmingId == null || this.vehicleId == null || this.vehicleType == null){
                    this.setPageTitle('No hay datos del vehículo')
                    this.pendingRequest(false);
                }else{
                    if(this.currentVehicleType() === farmingTypeOptions.harvest){
                        this.getHarvestDetail();
                    }
                    if(this.currentVehicleType() === farmingTypeOptions.sowing){
                        this.getSowingDetail();
                    }
                }
        })
    }

    setInitialPageTitle(){
        this.setPageTitle('Cargando...');
    }

    setLoadedPageTitle(vehicleDescription: string){
        let vehicleUrl = `${NAME_ROUTES.VEHICLES.path}${this.currentMachineId()}`
        let vehicleType = this.currentVehicleType();
        let link = `<a class="subtitle-1 white--text" target="_blank" title="Ver detalle de vehículo" href="${vehicleUrl}"> ${vehicleDescription}</a>`
        let pageTitle = `${getMachineTypeText(vehicleType)}: ${link}`
        this.setPageTitle(pageTitle)
    }

    setPageTitle(text: string){
        this.pageTitle = text;
    }

    currentMachineId(){
        return Number(this.vehicleId)
    }
    currentVehicleType(){
        return Number(this.vehicleType)
    }
    currentFarmingId(){
        return Number(this.farmingId)
    }
    currentVehicleId(){
        return Number(this.vehicleId)
    }

    reloadMachineDetail() {
        this.getHarvestDetail();
    }

    getHarvestDetail() {
        let self = this;
        this.pendingRequest(true);
        InsuranceServices.getVehicleHarvestDetail(this.currentMachineId(), this.currentFarmingId())
            .then(response => {
                this.updateVehicleAction('harvest');
                response['farming_id'] = self.farmingId;
                this.patchDataSowingDetail = response;
                this.setLoadedPageTitle(response.vehicle.description)
                this.showInfo = true;
                this.pendingRequest(false);
            })
            .catch(err => {
                this.updateVehicleAction('');
                this.detailFailed(err);
            });
    }

     getSowingDetail() {
        let self = this;
        this.pendingRequest(true);
        InsuranceServices.getVehicleSowingDetail(this.currentMachineId(), this.currentFarmingId())
            .then(response => {
                
                this.updateVehicleAction('sowing');
                response['farming_id'] = self.farmingId;
                this.patchDataSowingDetail = response;
                this.setLoadedPageTitle(response.vehicle.description);
                this.pendingRequest(false);
                this.showInfo = true;
            })
            .catch(err => {
                this.updateVehicleAction('');
                this.detailFailed(err);
            });
    }

    detailFailed(error){
        this.pendingRequest(false);
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: 'Ocurrio un error'
        })
    }

    updateVehicleAction(type: string) {
        this.vehicleAction = type;
    }


    pendingRequest(value){
        this.isLoading = value;
    }

}
